import {Params} from '@angular/router';

export const SNACK_BAR_FEATURE_KEY = 'snack-bar';

export const SNACK_BAR_TIMEOUT_MILLISECONDS = 6000;

export interface RouterLinkSnackBarConfig<RouteNameType extends string = string> {
  beforeLinkText?: string;
  linkText: string;
  afterLinkText?: string;
  routeName: RouteNameType;
  routeParams?: Params;
  queryParams?: Params;
}
